const prefix = 'notifications';

export const INFO = `${prefix}/INFO`;
export const ERROR = `${prefix}/ERROR`;
export const CLEAR_INFO = `${prefix}/CLEAR_INFO`;
export const CLEAR_ERROR = `${prefix}/CLEAR_ERROR`;
export const MANUAL_CLEAR_ERROR = `${prefix}/MANUAL_CLEAR_ERROR`;
